import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './components/auth/LoginPage';
import AdminLoginPage from './components/auth/AdminLoginPage';
import RegisterPage from './components/auth/RegisterPage';
import RoleBasedRedirect from './components/auth/RoleBasedRedirect';

// Pages
import Dashboard from './pages/Dashboard';

// Application pages
import ProductListing from './pages/application/ProductListing';
import ApplicationForm from './pages/application/ApplicationForm';
import ApplicationStatus from './pages/application/ApplicationStatus';

// Referral pages
import ReferralCapture from './pages/referral/ReferralCapture';
import ReferralLinks from './pages/referral/ReferralLinks';
import ReferralRegistration from './pages/referral/ReferralRegistration';

// User pages
import UserRewards from './pages/user/UserRewards';
import RedemptionCenter from './pages/user/RedemptionCenter';
import ReferralHistory from './pages/user/ReferralHistory';
import InviteFriends from './pages/user/InviteFriends';

// Partner pages
import PartnerPortal from './pages/partner/PartnerPortal';
import PartnerSubmission from './pages/partner/PartnerSubmission';
import DownlineManagement from './pages/partner/DownlineManagement';
import CommissionStatement from './pages/partner/CommissionStatement';
import PartnerMarketing from './pages/partner/PartnerMarketing';

// Agent pages
import CommissionTable from './pages/agent/CommissionTable';
import AgentPortal from './pages/agent/AgentPortal';
import AgentSales from './pages/agent/AgentSales';

// Profile page
import UserProfile from './pages/user/UserProfile';

// Admin pages
import AdminDashboard from './pages/admin/AdminDashboard';
import ReferralManagement from './pages/admin/ReferralManagement';
import PartnerApproval from './pages/admin/PartnerApproval';
import RewardConfig from './pages/admin/RewardConfig';
import ProductConfig from './pages/admin/ProductConfig';
import MarketingMaterials from './pages/admin/MarketingMaterials';
import UserManagement from './pages/admin/UserManagement';
import SalesListing from './pages/admin/SalesListing';
import CampaignSettings from './pages/admin/CampaignSettings';

// Notification page
import NotificationCenter from './pages/notifications/NotificationCenter';

export default function App() {
  return (
    <Routes>
      {/* Public routes (no layout, no auth) */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/referral" element={<ReferralCapture />} />

      {/* Protected routes within MainLayout */}
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          {/* Role-based root redirect */}
          <Route path="/" element={<RoleBasedRedirect />} />

          {/* Free User Dashboard */}
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Shared: Product Listing (all roles) */}
          <Route path="/products" element={<ProductListing />} />

          {/* Free User routes */}
          <Route path="/apply" element={<ApplicationForm />} />
          <Route path="/my-applications" element={<ApplicationStatus />} />
          <Route path="/rewards" element={<UserRewards />} />
          <Route path="/redemption" element={<RedemptionCenter />} />
          <Route path="/referral-history" element={<ReferralHistory />} />
          <Route path="/referral-links" element={<ReferralLinks />} />
          <Route path="/join-us" element={<ReferralRegistration />} />
          <Route path="/invite" element={<InviteFriends />} />

          {/* Partner routes */}
          <Route path="/partner" element={<PartnerPortal />} />
          <Route path="/partner/submit" element={<PartnerSubmission />} />
          <Route path="/partner/downline" element={<DownlineManagement />} />
          <Route path="/partner/commission" element={<CommissionStatement />} />
          <Route path="/partner/marketing" element={<PartnerMarketing />} />
          <Route path="/partner/applications" element={<ApplicationStatus />} />

          {/* Individual Agent routes */}
          <Route path="/commission-table" element={<CommissionTable />} />
          <Route path="/agent" element={<AgentPortal />} />
          <Route path="/agent/submit" element={<PartnerSubmission />} />
          <Route path="/agent/sales" element={<AgentSales />} />

          {/* Shared Profile (all roles) */}
          <Route path="/profile" element={<UserProfile />} />

          {/* Admin routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/referrals" element={<ReferralManagement />} />
          <Route path="/admin/partners" element={<PartnerApproval />} />
          <Route path="/admin/reward-config" element={<RewardConfig />} />
          <Route path="/admin/product-config" element={<ProductConfig />} />
          <Route path="/admin/marketing" element={<MarketingMaterials />} />
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/sales-listing" element={<SalesListing />} />
          <Route path="/admin/campaign-settings" element={<CampaignSettings />} />

          {/* Shared */}
          <Route path="/notifications" element={<NotificationCenter />} />

          {/* Catch all */}
          <Route path="*" element={<RoleBasedRedirect />} />
        </Route>
      </Route>
    </Routes>
  );
}
